import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakeB3AcoesRegistradoTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))

            setPagination({ count, next, previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            CodigoB3: "N/A",
            ISIN: "N/A",
            CodigoCFI: "N/A",
            Ativo: "N/A",
            DescricaoAtivo: "N/A",
            Segmento: "N/A",
            Mercado: "N/A",
            Categoria: "N/A",
            DataExpiracao: dayjs().format(DATE_FORMAT),
            DataInicioNegocio: dayjs().format(DATE_FORMAT),
            DataFimNegocio: dayjs().format(DATE_FORMAT),
            TipoOpcao: "N/A",
            TamanhoLote: 0,
            MoedaNegociada: "N/A",
            TipoEntrega: "N/A",
            PrecoExercicio: 0,
            EstiloOpcao: "N/A",
            IndicadorPremio: "N/A",
            IdentificadorDistribuicao: 0,
            FatorPreco: 0,
            Liquidacao: 0,
            TipoSerie: "N/A",
            IndicadorProtecao: "N/A",
            ExercicioAutomatico: "N/A",
            CodEspecificacao: "N/A",
            NomeInstituicao: "N/A",
            DataInicioEventoCorporativo: dayjs().format(DATE_FORMAT),
            TratamentoCustodia: "N/A",
            CapitalSocial: 0,
            GovernancaCorporativa: "N/A"
        }


        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            CodigoB3,
            ISIN,
            CodigoCFI,
            Ativo,
            DescricaoAtivo,
            Segmento,
            Mercado,
            Categoria,
            DataExpiracao,
            DataInicioNegocio,
            DataFimNegocio,
            TipoOpcao,
            TamanhoLote,
            MoedaNegociada,
            TipoEntrega,
            PrecoExercicio,
            EstiloOpcao,
            IndicadorPremio,
            IdentificadorDistribuicao,
            FatorPreco,
            Liquidacao,
            TipoSerie,
            IndicadorProtecao,
            ExercicioAutomatico,
            CodEspecificacao,
            NomeInstituicao,
            DataInicioEventoCorporativo,
            TratamentoCustodia,
            CapitalSocial,
            GovernancaCorporativa
        } = newRow

        const body = {
            CodigoB3,
            ISIN,
            CodigoCFI,
            Ativo,
            DescricaoAtivo,
            Segmento,
            Mercado,
            Categoria,
            DataExpiracao,
            DataInicioNegocio,
            DataFimNegocio,
            TipoOpcao,
            TamanhoLote,
            MoedaNegociada,
            TipoEntrega,
            PrecoExercicio,
            EstiloOpcao,
            IndicadorPremio,
            IdentificadorDistribuicao,
            FatorPreco,
            Liquidacao,
            TipoSerie,
            IndicadorProtecao,
            ExercicioAutomatico,
            CodEspecificacao,
            NomeInstituicao,
            DataInicioEventoCorporativo,
            TratamentoCustodia,
            CapitalSocial,
            GovernancaCorporativa
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row

        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        { field: 'ID', headerName: '#', disableColumnMenu: true, disableFilter: true, flex: true, minWidth: 80 },
        { field: 'CodigoB3', headerName: 'CodigoB3', flex: true, minWidth: 150, disableColumnMenu: true },
        { field: 'ISIN', headerName: 'ISIN', flex: true, minWidth: 150, disableColumnMenu: true },
        { field: 'CodigoCFI', headerName: 'CodigoCFI', flex: true, minWidth: 150, disableColumnMenu: true },
        { field: 'Ativo', headerName: 'Ativo', flex: true, minWidth: 120, disableColumnMenu: true },
        { field: 'DescricaoAtivo', headerName: 'DescricaoAtivo', flex: true, minWidth: 250, disableColumnMenu: true },
        { field: 'Segmento', headerName: 'Segmento', flex: true, minWidth: 200, disableColumnMenu: true },
        { field: 'Mercado', headerName: 'Mercado', flex: true, minWidth: 200, disableColumnMenu: true },
        { field: 'Categoria', headerName: 'Categoria', flex: true, minWidth: 200, disableColumnMenu: true },

        {
            field: 'DataExpiracao',
            headerName: 'DataExpiracao',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) =>
                value instanceof Date && !isNaN(value)
                    ? dayjs(value).format(DATE_FORMAT)
                    : '',
            disableColumnMenu: true
        },
        {
            field: 'DataInicioNegocio',
            headerName: 'DataInicioNegocio',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) =>
                value instanceof Date && !isNaN(value)
                    ? dayjs(value).format(DATE_FORMAT)
                    : '',
            disableColumnMenu: true
        },
        {
            field: 'DataFimNegocio',
            headerName: 'DataFimNegocio',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) =>
                value instanceof Date && !isNaN(value)
                    ? dayjs(value).format(DATE_FORMAT)
                    : '',
            disableColumnMenu: true
        },

        { field: 'TipoOpcao', headerName: 'TipoOpcao', flex: true, minWidth: 150, disableColumnMenu: true },
        { field: 'TamanhoLote', headerName: 'TamanhoLote', flex: true, minWidth: 150, type: 'number', disableColumnMenu: true },
        { field: 'MoedaNegociada', headerName: 'MoedaNegociada', flex: true, minWidth: 150, disableColumnMenu: true },
        { field: 'TipoEntrega', headerName: 'TipoEntrega', flex: true, minWidth: 150, disableColumnMenu: true },
        { field: 'PrecoExercicio', headerName: 'PrecoExercicio', flex: true, minWidth: 150, type: 'number', disableColumnMenu: true },

        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            createRow={createRow}
            deleteRow={deleteRow}
            updateRow={updateRow}
            filterFunction={onFilter}
            pagination={pagination}
            onChangePage={changePage}
            customFilter={true}
        />
    )
}

ParameterDatalakeB3AcoesRegistradoTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeB3AcoesRegistradoTable
